import { Box } from '@grupoboticario/flora-react'

interface VideoTimelineProps {
  videoProgress: number
}

export const VideoTimeline = ({ videoProgress }: VideoTimelineProps) => {
  return (
    <Box
      css={{
        width: `calc(100vw - $8)`,
        height: '$1',
        backgroundColor: '$statusInfoActionableContent',
        position: 'absolute',
        top: '$7',
        left: '$4',
        borderRadius: '$small',
        '&:after': {
          content: "''",
          display: 'block',
          width: `${videoProgress * 100}%`,
          height: '100%',
          borderRadius: '$small',
          backgroundColor: '$nonInteractiveEmphasis',
          position: 'relative',
          transition: 'width 0.5s linear',
        },
      }}
    />
  )
}
